import React from "react";

import { Link } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import { EpisodeEditDropdown } from "./EpisodeEditDropdown";
import mo3 from "../../assets/mo3.png";

import styles from "../../styles/Scene.module.css";

export default function EpisodeList({
  callEpi,
  episodes,
  currentUser,
  handleEpisodeDelete,
  getLink,
}) {

  return (
    <div className="mb-3">
      {/* <Row style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}> */}
      <Row>
        {episodes?.length <= 0 ? (
          <div>No episodes available.</div>
        ) : (
          <>
            {episodes?.map((episode, index) => (
              <Col
                key={episode?.id}
                xs={6}
                sm={4}
                md={3}
                lg={2}
                className="p-1 "
              >
                <Card
                  className={`text-center ${styles.SceneCard}`}
                  style={{ maxWidth: "200px", }}
                >
                  <div className={`mb-0 px-2 py-1`}>
                    <Row className={` ${styles.Div60} mx-0 px-0 d-flex align-items-center`}>
                      <Col className="mx-0 px-0" xs={1}>
                      </Col>
                      <Col xs={10} className="mx-0 px-0 text-center">
                        <Link to={getLink(episode)}>
                          <div>
                            <h5 className={` ${styles.Grey}`}>
                              Episode {episode?.episode_number}
                            </h5>
                          </div>
                        </Link>
                      </Col>
                      {callEpi ? (
                        <Col xs={1}></Col>
                      ) : (
                        <Col xs={1} className={`mx-0 px-0 ${styles.Drop}`}>
                          {currentUser &&
                            currentUser?.groups.length > 0 &&
                            (currentUser?.groups[0]?.name === "Admin" ||
                              currentUser?.groups[0]?.name === "Superadmin") && (
                              <EpisodeEditDropdown
                                episodeId={episode?.id}
                                handleEpisodeDelete={handleEpisodeDelete}
                              />
                            )}
                        </Col>
                      )}
                    </Row>
                  </div>
                  <Card.Body
                    style={{
                      backgroundImage: `url(${mo3})`,
                      objectFit: "fill",
                      width: "auto",
                      repeat: "no-repeat",
                    }}
                    className="py-1 px-0"
                  >
                    <Link to={getLink(episode)}>
                      <div className={` ${styles.Div10} px-0`}>
                        <Card.Text
                          style={{ fontWeight: "700" }}
                          className={` ${styles.Grey} px-0`}
                        >
                          {""}
                        </Card.Text>
                      </div>
                      <div className={` ${styles.Div50} px-0`}>
                        <p className={` ${styles.Grey3}`}>{episode?.title}</p>
                      </div>
                      <div className={`px-0 ${styles.Div10}`}>
                        <p className={` ${styles.Grey}`}>{""}</p>
                      </div>
                    </Link>
                    <Row>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </>
        )}
      </Row>
    </div>
  );
}
